import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { useProduct } from './product-context';
import Icon from '../utils/icon';

const ProductModels = (props) => {
  const { productModels, setSelectedModel } = useProduct();
  const [currentModel, setCurrentModel] = useState(productModels[0] || null);
  const [modalActive, setModalActive] = useState(false);

  useEffect(() => {
    if (productModels.length > 0) {
      setCurrentModel(productModels[0]);
      setSelectedModel(productModels[0]);
    } else {
      setCurrentModel(null);
      setSelectedModel(null);
    }
  }, [productModels, setSelectedModel]); // Runs when `productModels` changes

  const handleModal = () => {
    setModalActive(!modalActive);
  };

  const handleModelChange = (model) => {
    setCurrentModel(model);
    setSelectedModel(model);
    setModalActive(false);
  };

  return (
    <>
      {productModels.length > 0 && currentModel && (
        <div className={props.styles}>
          <div
            className="flex gap-x-5 justify-between cursor-pointer"
            onClick={handleModal}
          >
            <div className="flex gap-x-3 text-s5-d">
              <div>Size {currentModel.size}</div>
              <div className="text-grey-400">|</div>
              <div>
                {currentModel.name} is {currentModel.height}
              </div>
            </div>
            <div className="uppercase font-bold text-s5-d flex flex-nowrap gap-x-2 items-center">
              Change Model
              <Icon id="chevron-down" className="h-[10px] w-[10px]" />
            </div>
          </div>

          {modalActive && (
            <ul className="bg-white absolute left-0 bottom-0 w-full z-10 text-s5-d cursor-pointer p-3 flex flex-col gap-y-4">
              {productModels.map((model, index) => (
                <li
                  key={`model-${index}`}
                  className="flex gap-x-3"
                  onClick={() => handleModelChange(model)}
                >
                  <span className="w-11">Size {model.size}</span>
                  <div className="text-grey-400">|</div>
                  <span>
                    {model.name} is {model.height}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </>
  );
};

export default ProductModels;
